import React, { useState, useEffect, useCallback } from 'react';
import { Card, Spinner, Alert, Row, Col, Form, Button } from 'react-bootstrap';
import Select from 'react-select';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import api from './api';
import './RandevuTakvimi.css';

const zamanAraliklari = Array.from({ length: 18 }, (_, i) => {
  const saat = 9 + Math.floor(i / 2);
  const dakika = i % 2 === 0 ? '00' : '30';
  return `${saat.toString().padStart(2, '0')}:${dakika}`;
});

// YENİ EKLENDİ: Saat dilimi sorununu çözen yardımcı fonksiyon
const formatDateForAPI = (date) => {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
};

function RandevuAtama({ theme }) {
  const [danisanlar, setDanisanlar] = useState([]);
  const [diyetisyenler, setDiyetisyenler] = useState([]);
  const [diyetisyenProgrami, setDiyetisyenProgrami] = useState([]);
  
  const [seciliDanisan, setSeciliDanisan] = useState(null);
  const [seciliDiyetisyen, setSeciliDiyetisyen] = useState(null);
  const [seciliTarih, setSeciliTarih] = useState(new Date());
  const [seciliSaat, setSeciliSaat] = useState(null);
  const [konu, setKonu] = useState('');
  
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const verileriGetir = useCallback(async () => {
    try {
      setLoading(true);
      const [danisanRes, diyetisyenRes] = await Promise.all([
        api.get('/klinik/danisanlar'), 
        api.get('/klinik/diyetisyenler')
      ]);
      setDanisanlar(danisanRes.data.map(d => ({ value: d.id, label: `${d.ad} ${d.soyad}`, ...d })));
      setDiyetisyenler(diyetisyenRes.data.map(d => ({ value: d.id, label: d.kullanici_adi })));
    } catch (err) { 
      setError("Gerekli veriler yüklenirken bir hata oluştu."); 
    } finally { 
      setLoading(false); 
    }
  }, []);

  useEffect(() => {
    verileriGetir();
  }, [verileriGetir]);

  useEffect(() => {
    if (seciliDiyetisyen && seciliTarih) {
      // GÜNCELLENDİ: Güvenilir tarih formatlama fonksiyonunu kullanıyoruz
      const tarihStr = formatDateForAPI(seciliTarih);
      api.get(`/klinik/diyetisyen/${seciliDiyetisyen.value}/program?tarih=${tarihStr}`)
        .then(res => setDiyetisyenProgrami(res.data))
        .catch(err => console.error("Program alınamadı", err));
    }
  }, [seciliDiyetisyen, seciliTarih]);

  const handleDanisanChange = (selectedOption) => {
    setSeciliDanisan(selectedOption);
    if (selectedOption && selectedOption.diyetisyen_id) {
      const atanmisDiyetisyen = diyetisyenler.find(d => d.value === selectedOption.diyetisyen_id);
      if (atanmisDiyetisyen) {
        setSeciliDiyetisyen(atanmisDiyetisyen);
      }
    }
  };

  const handleDiyetisyenChange = (selectedOption) => {
    setSeciliDiyetisyen(selectedOption);
    setSeciliSaat(null);
  };

  const handleTarihChange = (newDate) => {
    setSeciliTarih(newDate);
    setSeciliSaat(null);
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!seciliDanisan || !seciliDiyetisyen || !seciliSaat) {
      setError("Lütfen danışan, diyetisyen ve uygun bir saat seçimi yapın.");
      return;
    }
    
    const [saat, dakika] = seciliSaat.split(':');
    const randevuTarihi = new Date(seciliTarih);
    randevuTarihi.setHours(saat, dakika, 0, 0);

    const year = randevuTarihi.getFullYear();
    const month = String(randevuTarihi.getMonth() + 1).padStart(2, '0');
    const day = String(randevuTarihi.getDate()).padStart(2, '0');
    const localDateTimeString = `${year}-${month}-${day}T${saat}:${dakika}:00`;

    const formData = {
      danisan_id: seciliDanisan.value,
      diyetisyen_id: seciliDiyetisyen.value,
      tarih_saat: localDateTimeString,
      konu: konu
    };

    setLoading(true);
    setError('');
    setSuccess('');
    try {
      await api.post('/klinik/randevular', formData);
      setSuccess('Randevu başarıyla oluşturuldu!');
      const newProgram = [...diyetisyenProgrami, seciliSaat];
      setDiyetisyenProgrami(newProgram);
      setSeciliDanisan(null);
      setSeciliDiyetisyen(null);
      setKonu('');
      setSeciliSaat(null);
      setTimeout(() => setSuccess(''), 4000);
    } catch (err) {
      setError(err.response?.data?.mesaj || 'Randevu oluşturulamadı.');
    } finally {
      setLoading(false);
    }
  };
  
  const selectStyles = {
    control: (styles) => ({ ...styles, backgroundColor: theme === 'dark' ? '#374151' : '#f8f9fa', borderColor: theme === 'dark' ? '#4b5563' : '#ced4da', color: 'white' }),
    menu: (styles) => ({ ...styles, backgroundColor: theme === 'dark' ? '#1f2937' : 'white' }),
    option: (styles, { isFocused }) => ({ ...styles, backgroundColor: isFocused ? (theme === 'dark' ? '#374151' : '#e9ecef') : 'transparent', color: theme === 'dark' ? 'white' : '#1f2937' }),
    singleValue: (styles) => ({ ...styles, color: theme === 'dark' ? 'white' : '#1f2937' }),
    input: (styles) => ({ ...styles, color: theme === 'dark' ? 'white' : '#1f2937' }),
    placeholder: (styles) => ({ ...styles, color: theme === 'dark' ? '#a1a1aa' : '#6c757d' }),
  };

  if (loading && danisanlar.length === 0) return <Spinner animation="border" variant={theme === 'dark' ? 'light' : 'dark'} />;

  return (
    <Card className="glass-card text-white">
      <Card.Header as="h2">Yeni Randevu Oluştur ve Ata</Card.Header>
      <Card.Body>
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={5}>
              <h5 className="mb-3">1. Atama Bilgileri</h5>
              <Form.Group className="mb-3">
                <Form.Label>Danışan Seçimi</Form.Label>
                <Select options={danisanlar} styles={selectStyles} value={seciliDanisan} onChange={handleDanisanChange} placeholder="Danışan ara veya seç..." isSearchable noOptionsMessage={() => "Danışan bulunamadı"}/>
              </Form.Group>
              
              {seciliDanisan && (
                <Alert variant="info" className="p-2 small">
                  <strong>Atanmış Diyetisyen:</strong> {seciliDanisan.diyetisyen_adi}<br />
                  <strong>Son Randevu:</strong> {seciliDanisan.son_randevu_tarihi ? new Date(seciliDanisan.son_randevu_tarihi).toLocaleDateString('tr-TR') : 'Yok'}
                </Alert>
              )}

              <Form.Group className="mb-3">
                <Form.Label>Atanacak Diyetisyen</Form.Label>
                <Select options={diyetisyenler} styles={selectStyles} value={seciliDiyetisyen} onChange={handleDiyetisyenChange} placeholder="Diyetisyen ara veya seç..." isSearchable noOptionsMessage={() => "Diyetisyen bulunamadı"}/>
              </Form.Group>
              <Form.Group>
                <Form.Label>Konu (İsteğe Bağlı)</Form.Label>
                <Form.Control className="glass-input" type="text" value={konu} onChange={(e) => setKonu(e.target.value)} placeholder="Örn: İlk Değerlendirme" />
              </Form.Group>
            </Col>

            <Col md={7}>
              <h5 className="mb-3">2. Tarih ve Saat Seçimi</h5>
              <div className="d-flex justify-content-center mb-3">
                <Calendar onChange={handleTarihChange} value={seciliTarih} locale="tr-TR" />
              </div>
              <div className="d-flex flex-wrap" style={{ gap: '8px' }}>
                {zamanAraliklari.map(saat => (
                  <Button 
                    key={saat}
                    variant={seciliSaat === saat ? 'primary' : (theme === 'dark' ? 'outline-light' : 'outline-secondary')}
                    disabled={!seciliDiyetisyen || diyetisyenProgrami.includes(saat)}
                    onClick={() => setSeciliSaat(saat)}
                  >
                    {saat}
                  </Button>
                ))}
              </div>
              {!seciliDiyetisyen && <Alert variant="warning" className="mt-3 small p-2">Müsait saatleri görmek için lütfen bir diyetisyen seçin.</Alert>}
            </Col>
          </Row>
          <hr className="my-4" />
          {error && <Alert variant="danger" className="mt-3" onClose={() => setError('')} dismissible>{error}</Alert>}
          {success && <Alert variant="success" className="mt-3">{success}</Alert>}
          <div className="d-flex justify-content-end">
            <Button type="submit" variant="primary" size="lg" disabled={loading}>
              {loading ? <Spinner as="span" size="sm" /> : 'Randevuyu Oluştur'}
            </Button>
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
}

export default RandevuAtama;